module.exports = __webpack_public_path__ + "img/ben-02.a4aa66f6.jpg";